var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommercialGrowthIcon = function SvgCommercialGrowthIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.385h9.846V64H0V39.385Z",
    fill: "#F4997D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 39.385h4.923V64H0V39.385Z",
    fill: "#E87F56"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.308 25.908h9.846V64h-9.846V25.908Z",
    fill: "#F4997D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.308 25.908h4.923V64h-4.923V25.908Z",
    fill: "#E87F56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.615 28.17h9.846V64h-9.846V28.17Z",
    fill: "#FFD553"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.615 28.17h4.923V64h-4.923V28.17Z",
    fill: "#EFB920"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.139 14.77h-.216V64h9.846V26.215a14.807 14.807 0 0 1-9.63-11.446ZM49.231 26.846v37.138h9.846V25.061c-2.17 1.262-4.692 2-7.384 2-.847.016-1.662-.076-2.462-.215Z",
    fill: "#1C7CE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M37.139 14.77h-.216V64h4.923V23.277a14.769 14.769 0 0 1-4.707-8.508ZM51.693 27.077c-.847 0-1.662-.092-2.462-.215V64h4.923V26.862c-.8.138-1.615.215-2.462.215Z",
    fill: "#014A99"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.692 24.615c-6.8 0-12.308-5.507-12.308-12.307C39.384 5.508 44.892 0 51.692 0S64 5.508 64 12.308s-5.508 12.307-12.308 12.307Z",
    fill: "#FFD553"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.846 12.308c0-6.385 4.861-11.631 11.077-12.246A10.81 10.81 0 0 0 51.692 0c-6.8 0-12.308 5.508-12.308 12.308s5.508 12.307 12.308 12.307c.415 0 .83-.015 1.23-.061-6.215-.631-11.076-5.877-11.076-12.246Z",
    fill: "#EFB920"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m44.739 17.662-.877-.877 5.354-5.354 2.461 2.461L56.17 9.4l.877.877-5.353 5.354-2.462-2.462-4.492 4.493Z",
    fill: "#014A99"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m54.154 7.385 4.923 4.923V7.385h-4.923Z",
    fill: "#014A99"
  })));
};
export default SvgCommercialGrowthIcon;